let projectData = [
  {
    id: 20251201,
    name: "Astroism",
    attributes: {
      languages: ["C#"],
      IDE: ["Unity"],
      Type: "Game",
    },
    description:
      "A 3D Unity adventure game featuring an astronaut cat exploring an alien spacecraft.",
    imageUrl: "AstroismScreen.png",
    link: "none",
  },
  {
    id: 20250901,
    name: "BetterDoctor",
    attributes: {
      languages: ["React", "TailwindCSS", "Firebase", "Gemini LLM"],
      IDE: ["VS Code"],
      Type: "Website",
    },
    description:
      "AI-assisted healthcare platform that streamlines patient intake and doctor workflows.",
    imageUrl: "BetterDoctorScreen.png",
    link: "https://github.com/ShaHos348/GTHack",
  },
  {
    id: 20250501,
    name: "MyExpense",
    attributes: {
      languages: ["JavaScript", "MongoDB"],
      IDE: ["React", "Node"],
      Type: "Website",
    },
    description:
      "MyExpense is a web app for tracking personal income and expenses.",
    imageUrl: "MyExpenseScreen.png",
    link: "https://shahbinhossain.com/demos/my-expense/",
  },
  {
    id: 20240501,
    name: "Ideal Course Mapping",
    attributes: {
      languages: ["TypeScript", "Python"],
      IDE: ["React", "Flask"],
      Type: "Website",
    },
    description:
      "Ideal Course Mapping is a tool for planning and visualizing GT course paths.",
    imageUrl: "IdealCourseMappingScreen.png",
    link: "https://shahbinhossain.com/demos/ideal-course-mapping/",
  },
  // {
  //   id: 20231215,
  //   name: "GT WebDev Project Platform",
  //   attributes: {
  //     languages: ["JavaScript", "Node.js", "MongoDB"],
  //     IDE: ["React"],
  //     Type: "Website",
  //   },
  //   description:
  //     "GT WebDev Project Platform is a showcase site for student projects.",
  //   imageUrl: "GTWebDevPlatformScreen.png",
  //   link: "https://github.com/ShaHos348/gt-webdev-project-platform",
  // },
  {
    id: 20230912,
    name: "Cosmic Crawlers",
    attributes: {
      languages: ["Java"],
      IDE: ["Android Studio"],
      Type: "Game",
    },
    description:
      "Cosmic Crawlers is a android dungeon crawler game featuring space cats.",
    imageUrl: "CosmicCrawlersScreen.png",
    link: "https://github.com/ShaHos348/Cosmic-Crawlers",
  },
  // {
  //   id: 20230201,
  //   name: "UGA MarketPlace",
  //   attributes: {
  //     languages: ["JavaScript", "Java"],
  //     IDE: ["React", "Firebase"],
  //     Type: "Website",
  //   },
  //   description:
  //     "UGA MarketPlace is a student-to-student service and item exchange site.",
  //   imageUrl: "UGAMarketPlaceScreen.png",
  //   link: "https://github.com/ShaHos348/openSourceSpring23",
  // },
  // {
  //   id: 20221205,
  //   name: "Space Invaders",
  //   attributes: {
  //     languages: ["Java"],
  //     IDE: ["Shell"],
  //     Type: "Game",
  //   },
  //   description:
  //     "Space Invaders is an implementation of the classic arcade game of the same name.",
  //   imageUrl: "SpaceInvadersScreen.png",
  //   link: "none",
  // },
  // {
  //   id: 20220101,
  //   name: "Time Warp",
  //   attributes: {
  //     languages: ["C#"],
  //     IDE: ["Unity"],
  //     Type: "Game",
  //   },
  //   description:
  //     "Time Warp is a 2D platformer game based on time travel through eras.",
  //   imageUrl: "TimeWarpScreen.png",
  //   link: "https://github.com/ShaHos348/Time-Warp",
  // },
];

projectData.sort((a, b) => b.id - a.id);

export default projectData;
